/** Naming a map object from its def id, on the host side.
 *
 * The shell already does this in `objectDisplayName` (adventure/describe.ts),
 * but that one takes an `ObservedObject` and the journal is walking `GameState`
 * - it has the def id and nothing else. Rather than fake an observation, the
 * id-stripping half is repeated here against the same rules, which are stated
 * in full in `describe.ts` and are two regular expressions.
 */

import type { ContentRegistry } from "@game/core";
import { titleCase } from "@game/ui";

const VENDOR_PREFIX = /^(?:obj)[._]/;
const FAMILY_PREFIX = /^(?:bld|bank|mine|dwl|mon|res|pu|tp|obs|boat)[._]/;

export function objectDisplayNameOf(def: string, content: ContentRegistry): string {
  void content;
  let stripped = def;
  for (;;) {
    const next = stripped.replace(VENDOR_PREFIX, "");
    if (next === stripped) break;
    stripped = next;
  }
  stripped = stripped.replace(FAMILY_PREFIX, "").replace(/[._]obj$/, "");
  return titleCase(stripped.replace(/[._]/g, " "));
}
